export default (value, decimals = 2) => {
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return '';

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(parsed);
};
